<div class="panel panel-default create-video-request">
    <div class="panel-heading">
        <h3 class="panel-title">Video Request Details</h3>
    </div>
    <div class="panel-body">
        <form class="form-horizontal" novalidate>
            <div class="row m-b-15">
                <div class="col-sm-6">
                    <label class="control-label" for="name">Name</label>
                    <input [attr.data-cy]="this.userInfo.name"
                           class="form-control"
                           disabled
                           id="name"
                           name="name"
                           placeholder="{{ this.userInfo.name }}">
                </div>
                <div class="col-sm-6">
                    <label class="control-label"
                       for="email">Email</label>

                    <input [attr.data-cy]="this.userInfo.email"
                           class="form-control"
                           disabled
                           id="email"
                           name="email"
                           placeholder="{{ this.userInfo.email }}"
                           type="email">
                </div>
            </div>

            <div class="row m-b-15">
                <div class="col-sm-4">
                    <label class="control-label" for="truck">Unit</label>
                    <input [attr.data-cy]="truckNumber" 
                           class="form-control"
                           disabled
                           id="truck"
                           name="truck"
                           placeholder="{{ truckNumber }}">
                </div>
                <div class="col-sm-4">
                    <label class="control-label" for="truck">Business</label>
                    <input [attr.data-cy]="businessCaption" 
                           class="form-control"
                           disabled
                           id="business"
                           name="business"
                           placeholder="{{ businessCaption }}">
                </div>
                <div class="col-sm-4">
                    <label class="control-label" for="computer">Device</label>
                    <input [attr.data-cy]="deviceId"
                           class="form-control"
                           disabled
                           id="computer"
                           name="computer"
                           placeholder="{{ deviceId }}">
                </div>
            </div>

            <div class="row m-b-15">
                <div class="col-sm-12" *ngIf="this.userInfo.isFreeUser">
                    <label for="check_freeDownload" class="col-sm-3 control-label">Free Download</label>
                    <div class="col-sm-9">
                        <div class="checkbox">
                            <label>
                                <input #fd
                                       (change)="onFreeDownloadChanged(fd.checked)"
                                       id="check_freeDownload"
                                       name="check_freeDownload"
                                       type="checkbox"
                                       [(ngModel)]="isFreeDownload"
                                       required />
                            </label>
                        </div>
                    </div>
                </div>
            </div>


            <div class="row m-b-15">
                <div class="col-xs-12">
                    <label class="control-label">Cameras&nbsp;&nbsp;</label>
                    <div class="checkbox"
                         *ngFor="let camera of cameras">
                        <label for="check_{{camera}}">
                            <input #cb
                                   (change)="onCameraSelected(camera, cb.checked)"
                                   id="check_{{camera}}"
                                   name="check_{{camera}}"
                                   type="checkbox"
                                   required>{{ camera }}
                        </label>
                    </div>
                    <div class="invalid-feedback"
                         [hidden]="hasAtLeastOneSelectedCamera()">Please choose 1 or more cameras</div>
                </div>
            </div>

            <div class="row m-b-15">
                <div class="col-sm-4">
                    <label class="control-label">Date</label>
                    <div class="datepicker-wrapper">
                        <input class="form-control"
                               [disabled]="datePickerShouldBeDisabled()"
                               id="requestdate"
                               name="requestdate"
                               placeholder="{{ formattedDate }}"
                               [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', containerClass: 'theme-default' }"
                               [(ngModel)]="formattedDate"
                               [ngModelOptions]="{ standalone: true }"
                               [minDate]="minPickerDate"
                               [maxDate]="maxPickerDate"
                               bsDatepicker>
                        <div>Date and time in the site {{ site }} local timezone (UTC{{ offsetCaption }})</div>
                        <div class="invalid-feedback"
                             [hidden]="hasValidRequestDate()">Please enter a date between {{ oldest.format("DD/MMM/YYYY") }} and today</div>
                    </div>
                </div>

                <div class="col-sm-4">
                    <label class="control-label inline-label">From</label>
                    <div class="select-wrapper">
                        <ng-select data-cy="selected-from-hour"
                                   class="custom-select"
                                   [items]="hours"
                                   [(ngModel)]="selectedFromHour"
                                   [clearable]="false"
                                   [ngModelOptions]="{standalone: true}">
                        </ng-select>

                        <ng-select data-cy="selected-from-minute"
                                   class="custom-select"
                                   [items]="minutes"
                                   [(ngModel)]="selectedFromMinute"
                                   [clearable]="false"
                                   [ngModelOptions]="{standalone: true}">
                        </ng-select>

                        <ng-select data-cy="selected-from-meridiem"
                                   class="custom-select"
                                   [items]="meridiems"
                                   [(ngModel)]="selectedFromMeridiem"
                                   [clearable]="false"
                                   [ngModelOptions]="{standalone: true}">
                        </ng-select>
                    </div>
                </div>

                <div class="col-sm-4">
                    <label class="control-label inline-label">To</label>
                    <div class="select-wrapper">
                        <ng-select data-cy="selected-to-hour"
                                   class="custom-select"
                                   [items]="hours"
                                   [(ngModel)]="selectedToHour"
                                   [clearable]="false"
                                   [ngModelOptions]="{standalone: true}">
                        </ng-select>

                        <ng-select data-cy="selected-to-minute"
                                   class="custom-select"
                                   [items]="minutes"
                                   [(ngModel)]="selectedToMinute"
                                   [clearable]="false"
                                   [ngModelOptions]="{standalone: true}">
                        </ng-select>

                        <ng-select data-cy="selected-to-meridiem"
                                   class="custom-select"
                                   [items]="meridiems"
                                   [(ngModel)]="selectedToMeridiem"
                                   [clearable]="false"
                                   [ngModelOptions]="{standalone: true}">
                        </ng-select>
                    </div>
                    <div class="invalid-feedback"
                         [hidden]="hasValidRequestTime()">Please enter a time in the past</div>
                    <div class="invalid-feedback"
                         [hidden]="hasValidRequestLengthOrZero()">Video requests cannot be longer than&nbsp;{{ maxAllowedMinutes }}&nbsp;minutes in length</div>
                    <div class="invalid-feedback"
                         [hidden]="hasRequestLengthNonZero()">Video requests cannot be less than 1 minute in length</div>
                </div>
            </div>


            <div class="row m-b-15">
                <div class="col-sm-12">
                    <label class="control-label" for="title">Title</label>
                    <input class="form-control"
                           id="title"
                           name="title"
                           [(ngModel)]="title"
                           placeholder="e.g. Non-Collection"
                           type="text">
                    <div class="invalid-feedback" [hidden]="title">Please enter a valid title</div>
                </div>
            </div>

            <div class="row m-b-15">
                <div class="col-sm-12">
                    <label class="control-label" for="reason">Reason</label>
                    <textarea class="form-control"
                              id="reason"
                              name="reason"
                              [(ngModel)]="reason"
                              placeholder="e.g. Fulfilling request from council to investigate bin non-collection..."
                              rows="5"></textarea>
                    <div class="invalid-feedback" [hidden]="hasValidReasonLength()">Reason cannot be longer than 1000 characters</div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12 text-center m-t-15">
                    <button data-cy="request-submit"
                            class="btn btn-success fullwidth"
                            data-toggle="modal"
                            data-target="#disclaimerModal"
                            [disabled]="!isValid()"
                            type="button">
                        Submit
                    </button>
                </div>
            </div>
        </form>
    </div>
    <div class="modal fade" id="disclaimerModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4>Video Retrieval Request</h4>
                </div>
                <div class="modal-body">
                    <p>By proceeding with this request you agree to abide by the Video Portal Terms of Use.</p>
                    <p *ngIf="cost > 0">
                        If you proceed {{ organisation }} will be charged ${{ cost | number:'1.2-2' }} for this retrieval.
                    </p>
                </div>
                <div class="modal-footer">
                    <button data-cy="cancel" type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>
                    <button data-cy="agree-and-proceed"
                            type="button"
                            class="btn btn-success"
                            (click)="requestVideo()"
                            data-dismiss="modal">
                        Agree &amp; Proceed
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="freeDownloadDisclaimerModal" tabindex="-1" role="dialog" #freeDownloadDisclaimerModal>
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4>Free Video Download</h4>
                </div>
                <div class="modal-body">
                    <p>Free video downloads are only available for Waste Management and are not to be used for any other purpose.</p>
                </div>
                <div class="modal-footer">
                    <button type="button"
                            class="btn btn-default"
                            (click)="rejectFreeDownload()"
                            data-dismiss="modal">
                        Cancel
                    </button>
                    <button type="button"
                            class="btn btn-success"
                            data-dismiss="modal">
                        Agree &amp; Proceed
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
